export const isValidTime = (time: string | undefined) => {
  if (!time) return true
  if (time.length !== 8) return false
  const arr = [...time]
  const isTimeCorrect = (arr: string[]) => {
    if (Number(arr[0] + arr[1]) >= 24) return false
    if (Number(arr[3] + arr[4]) >= 60) return false
    if (Number(arr[6] + arr[7]) >= 60) return false
    if (arr[2] !== ':') return false
    if (arr[5] !== ':') return false
    return true
  }
  return isTimeCorrect(arr)
}

export const normalizeTimeString = (time: string) => {
  // days.hours:minutes:seconds:milliseconds
  const [
    milliseconds = '000000',
    seconds = '00',
    minutes = '00',
    hours = '00',
    days = '0',
  ] = time.split(/[^0-9]/).reverse()
  return `${days.padStart(5, '0')}.${hours.padStart(2, '0')}:${minutes.padStart(
    2,
    '0'
  )}:${seconds.padStart(2, '0')}:${milliseconds.padStart(6, '0')}`
}

export const formatTimeString = (time: string) => {
  // days.hours:minutes:seconds:milliseconds
  const [
    _milliseconds,
    _seconds,
    minutes = '0',
    hours = '0',
    days = '0',
  ] = time.split(/[^0-9]/).reverse()
  const numericDays = Number(days)
  const numericHours = Number(hours)
  const numericMinutes = Number(minutes)
  if (numericDays >= 1)
    return `${numericDays} ${numericDays > 1 ? 'days' : 'day'}`
  if (numericHours >= 1)
    return `${numericHours} ${numericHours === 1 ? 'hour' : 'hours'}`
  return `${numericMinutes} ${numericMinutes === 1 ? 'minute' : 'minutes'}`
}
